var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-testing"},[(_vm.snapshotsMissing)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"color-testing__no-data"},[_vm._v("Awaiting Data")])]):[_c('PieChart',{staticClass:"charts__pie"}),_c('AreaChart',{ref:"chart",staticClass:"color-testing__chart",attrs:{"selectedType":"msv","cells":_vm.cells}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }